import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import { IContact } from '../../../../interfaces';
import store from '../../../app/Store';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}/vendor`;

interface IState {
  data: IContact[];
  type: any;
  loading: boolean;
  done: boolean;
  showError: boolean;
  error: any;
}

const initialState: IState = {
  data: [],
  loading: false,
  type: [],
  done: false,
  error: null,
  showError: false,
};

export const addContact = createAsyncThunk('contact/add', async (data: Omit<IContact, 'id'>) => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  const res = await axios.post<IContact>(`${VENDOR_MC_URL}/${userId}/contact/add`, data);
  return res.data;
});

export const getContactType = createAsyncThunk('contact/type', async () => {
  const {
    auth: { user },
  } = store.getState();
  const res = await axios.get<IContact[]>(`${VENDOR_MC_URL}/${user?.vendor?.id}/contact/type/list`);
  return res.data;
});

export const getContactList = createAsyncThunk('contact/list', async () => {
  const {
    auth: { user },
  } = store.getState();
  const res = await axios.get<IContact[]>(`${VENDOR_MC_URL}/${user?.vendor?.id}/contact/list`);
  return res.data;
});

export const updateContact = createAsyncThunk('contact/edit', async (data: IContact) => {
  const {
    auth: { user },
  } = store.getState();

  const res = await axios.post<IContact>(`${VENDOR_MC_URL}/${user?.vendor?.id}/contact/${data.id}/edit`, data);
  return res.data;
});

export const deleteContact = createAsyncThunk('contact/delete', async (id: number) => {
  const {
    auth: { user },
  } = store.getState();
  const res = await axios.post<IContact>(`${VENDOR_MC_URL}/${user?.vendor?.id}/contact/${id}/delete`);
  return res.data;
});

const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.showError = action.payload;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(addContact.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(addContact.fulfilled, (state, action) => {
      state.loading = false;
      state.data = [action.payload].concat(state.data);
      state.done = true;
    });
    builder.addCase(addContact.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Veri eklenemedi.';
    });
    //
    builder.addCase(getContactList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getContactList.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.done = true;
    });
    builder.addCase(getContactList.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Liste bulunamadı.';
    });
    //
    builder.addCase(getContactType.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getContactType.fulfilled, (state, action) => {
      state.type = action.payload;
      state.loading = false;
      state.done = true;
    });
    builder.addCase(getContactType.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! İletişim türleri listenemedi.';
    });
    //
    builder.addCase(updateContact.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updateContact.fulfilled, (state, action) => {
      const index: number = state.data?.findIndex((item) => item.id === action.payload?.id);
      state.data[index] = action.payload;
      state.loading = false;
      state.done = true;
    });
    builder.addCase(updateContact.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Veri Güncellenemedi.';
    });
    //
    builder.addCase(deleteContact.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(deleteContact.fulfilled, (state, action) => {
      const index: any = state.data?.findIndex((item) => item.id === action?.payload.id);
      state.data?.splice(index, 1);
      state.loading = false;
      state.done = true;
    });
    builder.addCase(deleteContact.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Veri silinemedi.';
    });
  },
});
export const { setError } = contactSlice.actions;
export default contactSlice.reducer;
